export const messagesLoaders = {
  en: () => import('./en.json'),
  ro: () => import('./ro.json'),
  th: () => import('./th.json'),
} as const;
